import * as React from "react";

import { IUser } from "../../api/models/IUser";
import { TResourceState } from "../../types/TResourceState";

type TMode = 'list' | 'view' | 'add' | 'edit';

interface IUsersContext {
  /** UserManager operating mode. */
  mode: TMode;
  setMode: (mode: TMode) => void;

  /** Add/edit user tab */
  tab: 'systems' | 'data';
  setTab: (value: 'systems' | 'data') => void;  

  /** Currently loaded user proxies. */
  users: IUser[];
  setUsers: (users: IUser[]) => void;
  usersReady: TResourceState;
  loadUsers: () => void;
  
  /** Selected user proxy. */
  user: IUser | null;
  setUser: (user: IUser | null) => void;
  userReady: TResourceState;
  setUserReady: (value: TResourceState) => void;

  loadUser: (uuid: string) => void;
  createUser: (user: IUser, signal: AbortSignal) => Promise<TResourceState>;
  updateUser: (user: IUser, signal: AbortSignal) => Promise<TResourceState>;
  deleteUser: () => void;
}

const UsersContext = React.createContext<IUsersContext | null>(null);

const useUsersContext = (): IUsersContext => {
  const ctx = React.useContext(UsersContext);
  if (!ctx) throw new Error('useUsersContext must be used inside a <UsersContext> provider.');
  return ctx;
}

export { UsersContext, IUsersContext, useUsersContext, TMode }
